






























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  GetNewCanvas,
  SymbolConfig,
  Type,
} from "@/components/ciphertexts/Ciphertext";

@Component<SymbolTable>({})
export default class SymbolTable extends Vue {
  @Prop({ required: true })
  table: SymbolConfig[][];
  @Prop({ required: true })
  type: Type;
  @Prop()
  selected: [number, number];

  mounted() {
    this.drawShapes();
  }

  updated() {
    this.drawShapes();
  }

  drawShapes() {
    this.table.forEach((row, rowIndex) => {
      row.forEach((shapes, shapeIndex) => {
        const cvShape = GetNewCanvas(
          this.type,
          document.getElementById(
            `shape-${rowIndex}-${shapeIndex}`
          ) as HTMLCanvasElement
        );
        cvShape.draw(shapes);
      });
    });
  }

  isSelected(rowIndex: number, shapeIndex: number): boolean {
    return (
      JSON.stringify([rowIndex, shapeIndex]) == JSON.stringify(this.selected)
    );
  }

  selectSymbol(rowIndex: number, shapeIndex: number) {
    if (rowIndex === 0 || shapeIndex === 0) {
      return;
    }
    this.$emit("symbol-selected", rowIndex, shapeIndex);
  }
}
